import React, { Component } from 'react';
import githubImg from "./imgs/github.png";
import netlifyImg from "./imgs/netlify.png"
import "./ProjectDetails.scss";

export default class ProjectDetails extends Component {
    render() {
        let { project } = this.props;
        return (
            <div className="ProjectDetails">
                <h1>{project.title}</h1>
                <h2>Technology: {project.technology}</h2>
                <a href={project.link}><img className="ProjectDetailsImg" src={project.src} alt={project.name} /></a>
                <div className="container">
                    <p>{project.description}</p>
                    <p>{project.struggle}</p>
                </div>
                <div className="row">
                    <div className="col-6">
                        <a href={project.git}>
                            <h3>Source Code</h3>
                            <img src={githubImg} className="ProjectDetailsLogo" alt="Link to Github Code" />
                        </a>
                    </div>
                    <div className="col-6">
                        <a href={project.link}>
                            <h3>Full Website Deployed on Netlify</h3>
                            <img src={netlifyImg} className="ProjectDetailsLogo" alt="Link to Website" />
                        </a>
                    </div>
                </div>
                <div className="blankSpace"></div>
            </div>
        )
    }
}
